import { render, staticRenderFns } from "./ResourceRepReportListBlock.vue?vue&type=template&id=070efc13&"
import script from "./ResourceRepReportListBlock.vue?vue&type=script&lang=js&"
export * from "./ResourceRepReportListBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports